import {useAuth} from "context/AuthContext";
import {useChat} from "hooks/useChat";
import styled from "styled-components";
import {NoContent} from "ui/base/NoContent/NoContent";
import {Chat} from "ui/blocks/chat/Chat";
import {ChatList} from "ui/blocks/chat/ChatList";
import NoMessagesFound from "ui/icons/not-found-icons/noMessages.svg";
import {fonts, pageContainerStyles, themeColor} from "ui/theme";
import {useMediaQuery} from "react-responsive";
import {useEffect, useState} from "react";
import {PrevButton} from "ui/base/Button/EmblaButtons";
import { LoaderComponent } from "ui/base/loading/LoaderComponent";
import {UserProfileModal} from "ui/base/class/UserProfileModal";

export const InstructorMessages = ({setMobileOverlayVisibility, activeRequest}) => {
    const {userData} = useAuth();

    // senderId
    const currentUserId = userData?.id;

    const [selectedMobileChat, setSelectedMobileChat] = useState(null);
    const [activeUserId, setActiveUserId] = useState(activeRequest);

    const [showUserModal, setShowUserModal] = useState(false);
    // Modal
    const [selectedUserId, setSelectedUserId] = useState(null);

    useEffect(() => {
        if (activeRequest)
            setActiveUserId(activeRequest)
    }, [activeRequest])

    const {
        chatMessages, // messages
        chatList, // messageList
        activeConversation, // conversationSelected
        handleSelectConversation, // onClickMessage
        handleSendMessage,
        isLoading,
        isLoadingChat,
    } = useChat(currentUserId, 2, activeUserId);


    const handleSelection = (c) => {
        setActiveUserId(null);
        handleSelectConversation(c);
        setSelectedMobileChat(c);
    }

    const isMobile = useMediaQuery({query: "(max-width: 768px)"});

    if (isLoading)
        return (
            <>
                <Title>{"Messages"}</Title>
                <LoadingContainer>
                    <LoaderComponent minHeight="auto" />
                </LoadingContainer>
            </>
        );

    return (
        <>

            {selectedUserId && showUserModal ? (
                <UserProfileModal
                    show={showUserModal}
                    handleClose={() => {
                        setSelectedUserId(null);
                        setShowUserModal(false);
                    }}
                    handleSendMessage={() => {
                        setActiveUserId(selectedUserId);
                        setShowUserModal(false);
                        setSelectedBooking(null);
                    }}
                    userId={selectedUserId}
                    isInstructor
                />
            ) : null}

            {isMobile
                ?
                <OverlayHeader>
                    <PrevButton
                        onClick={() => {
                            setMobileOverlayVisibility(false);
                        }}
                    >
                    </PrevButton>
                    <h2>
                        Messages
                    </h2>
                </OverlayHeader> : null}
            {chatList?.length ? (
                <Container>
                    {isMobile ? (
                        <>
                            {selectedMobileChat != null ? (
                                <Chat
                                    messages={chatMessages}
                                    conversation={selectedMobileChat}
                                    currentUserId={currentUserId}
                                    onGoBack={() => {
                                        if (selectedMobileChat) {
                                            setSelectedMobileChat(null);
                                        }
                                    }}
                                    isLoading={isLoadingChat}
                                    handleAvatarClick={((id) => {
                                        setSelectedUserId(id);
                                        setShowUserModal(true)
                                    })}
                                />
                            ) : (
                                <ChatList
                                    chatList={chatList}
                                    onClickMessage={(c) => {
                                        handleSelection(c)
                                    }}
                                    activeConversation={activeConversation}
                                    currentUserId={currentUserId}
                                    handleAvatarClick={((id) => {
                                        setSelectedUserId(id);
                                        setShowUserModal(true)
                                    })}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            <ChatList
                                chatList={chatList}
                                onClickMessage={((c) => {
                                    handleSelection(c)
                                })}
                                activeConversation={activeConversation}
                                currentUserId={currentUserId}
                                handleAvatarClick={((id) => {
                                    setSelectedUserId(id);
                                    setShowUserModal(true)
                                })}
                            />
                            <Chat
                                messages={chatMessages}
                                sendMessage={handleSendMessage}
                                conversation={activeConversation}
                                currentUserId={currentUserId}
                                isLoading={isLoadingChat}
                                handleAvatarClick={((id) => {
                                    setSelectedUserId(id);
                                    setShowUserModal(true)
                                })}
                            />
                        </>
                    )}
                </Container>
            ) : (
                <NoContent
                    title="You have no Messages"
                    image={NoMessagesFound}
                    size={280}
                />
            )}{" "}
        </>
    );
};

const Container = styled.div`
    ${pageContainerStyles}
    font-family: var(--font-secondary);
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;

    @media (min-width: 1024px) {
        grid-template-columns: 1fr 2fr;
    }
`;

const Title = styled.p`
    font-size: ${fonts.sizes.medium};
    font-weight: 600;
    text-align: left;
    text-transform: capitalize;
    padding: 1rem;
    font-family: var(--font-secondary);

    @media (max-width: 1024px) {
        display: none;
    }
`;

const LoadingContainer = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    align-content: center;
    text-align: center;
`;

const OverlayHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 2rem;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #eee;

    h2 {
        margin: 0;
        font-size: 1.2rem;
        color: #333;
    }
`;

const CloseButton = styled.button`
    background: none;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    align-content: center;

    padding: 0.5rem;
    border: 1px solid ${themeColor("mobileInputBorder")};
    border-radius: 6px;
`;
